import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/integrations/axios/axios-instance'

export function useEmailQuery(html: string | null) {
  return useQuery({
    queryKey: ['email-image', html],
    queryFn: async () => {
      if (!html) throw new Error('No HTML provided')
      const response = await axiosInstance.post(
        '/email-preview/email-image',
        { html },
        { responseType: 'blob' },
      )
      return URL.createObjectURL(response.data)
    },
    enabled: !!html,
    staleTime: 1000 * 60 * 60,
  })
}
